export enum SettlementType {
  NotSet = 'NotSet',
  Month = 'Month',
  Hour = 'Hour',
  ForContract = 'ForContract',
}
export enum SettlementTypeByNumber {
  NotSet = 1,
  Month = 2,
  Hour = 3,
}
